import React from "react";
import type {BaseError} from "../utils/baseError";

const FallbackPage: React.FC<{baseError: BaseError}> = ({baseError}) => {
    const context = baseError.context as {place: string, status: string}

    return <div className="center-div">
        <h1>{context.status}</h1>
        <p>{`${baseError.cause}`}</p>
    </div>
}

export default FallbackPage
